import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';

import 'dayjs/locale/en';
import 'dayjs/locale/nb';
import 'dayjs/locale/da';
import 'dayjs/locale/sv';

dayjs.extend(localizedFormat);
dayjs.extend(utc);

export default dayjs;
